var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "steps-row", class: { expanded: _vm.expanded } },
    [
      _c(
        "div",
        {
          staticClass: "steps-header",
          on: {
            click: function ($event) {
              _vm.expanded = !_vm.expanded
            },
          },
        },
        [
          _c("i", { staticClass: "fas fa-list-ul" }),
          _vm._v(" "),
          _c("span", { staticClass: "steps-count-text" }, [
            _vm._v(_vm._s(_vm.headerText)),
          ]),
          _vm._v(" "),
          _c("i", { staticClass: "fas fa-chevron-right" }),
        ]
      ),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "steps-list" },
        _vm._l(_vm.steps, function (step, index) {
          return _c("li", { key: index }, [
            _vm._v(_vm._s(step.label || step.name)),
          ])
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }